import { Alert, Box, Button, Paper, Skeleton, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link as RouterLink } from 'react-router';
import { useMyAllotment, useMyReferrals } from '../api/hooks';
import { describeError } from '../components/Notify';
import { AllotmentUsageList, ReferralCardList } from '../referrals/ReferralCards';

export function MyReferralsPage() {
  const list = useMyReferrals();
  const usage = useMyAllotment();

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2} gap={2}>
        <Typography variant="h2">My Referrals</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          component={RouterLink}
          to="/my-referrals/new"
        >
          New referral
        </Button>
      </Stack>
      <Paper component="section" aria-labelledby="my-recommendations-summary" sx={{ p: 2, mb: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ sm: 'center' }}
          gap={2}
        >
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography variant="h3" component="h3" id="my-recommendations-summary" mb={0.5}>
              My Recommendations
            </Typography>
            {usage.isPending ? (
              <Skeleton width="60%" />
            ) : usage.error ? (
              <Alert severity="error">
                Could not load your recommendation usage: {describeError(usage.error)}
              </Alert>
            ) : (
              <AllotmentUsageList cycles={usage.data.cycles} limit={usage.data.limit} />
            )}
          </Box>
          <Button variant="outlined" component={RouterLink} to="/my-recommendations">
            View my recommendations
          </Button>
        </Stack>
      </Paper>
      {list.isPending ? (
        <Stack gap={2}>
          <Skeleton variant="rounded" height={88} />
          <Skeleton variant="rounded" height={88} />
        </Stack>
      ) : list.error ? (
        <Alert severity="error">Could not load your referrals: {describeError(list.error)}</Alert>
      ) : (
        <ReferralCardList
          rows={list.data.filter((r) => !r.countsTowardAllotment)}
          empty={
            list.data.length
              ? 'You have no referrals other than your recommendations.'
              : 'You have no referrals yet.'
          }
        />
      )}
    </Box>
  );
}
